import React from 'react';
import { Input, Modal, ModalBody } from 'reactstrap';

import history from '../../../../utils/history';
import CircularLoading from '../../../Common/CircularLoading/CircularLoading';

const OPTIONS_MAPPER = {
  tech: 'I was promoted!',
  content: 'I am awaiting advancement results',
  need: 'I am separating from the service',
  other: 'Other',
};

const TITLE_MAPPER = {
  stepOne: {
    title: 'Before You Cancel',
    subtitle: 'Consider pausing your subscription for 3 months',
  },
  main: {
    title: 'We hope to see you soon.',
    subtitle: 'Can you tell us why you are cancelling?',
    bodyMessage: '',
  },
  need: {
    title: 'I am separating from the service',
    subtitle: 'Let us help you',
    bodyMessage: [
      'Our educational partners can help you earn a degree FAST to enhance the technical skills you learned in the Air Force. Employers want experience AND degrees! We can help you hit the ground running with a G.I. Bill approved degree in as fast as five credits.',
    ],
    buttonLabel: 'WARFARE QUALIFICATIONS',
  },
  other: {
    title:
      'Tell us how we can improve our experience to help you meet your career needs!',
    subtitle: '',
    bodyMessage: [''],
    buttonLabel: 'CANCEL SUBSCRIPTION',
  },
};

const noSpacesRegex = /(?!^\s+$)^.*$/m;

class CancelPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stepOne: false,
      stepTwo: false,
      selectedOption: '',
      modalContentState: 'main',
      cancellationReason: '',
    };
  }

  handleOnSubmit = () => {
    if (this.state.selectedOption == 'other') this.setState({ stepTwo: true });
    switch (this.state.modalContentState) {
      case 'main':
        if (
          this.state.selectedOption === 'tech' ||
          this.state.selectedOption === 'content'
        ) {
          this.props.cancelSubscription(
            OPTIONS_MAPPER[this.state.selectedOption],
          );
        } else {
          this.setState({ modalContentState: this.state.selectedOption });
        }
        break;
      case 'need':
        this.resetModal();
        history.push('study/quals-and-certs');
        break;
      case 'other':
        this.resetModal();
        if (this.state.cancellationReason !== '') {
          this.props.cancelSubscription(
            `${OPTIONS_MAPPER.other} - ${this.state.cancellationReason}`,
          );
        } else {
          this.props.cancelSubscription(OPTIONS_MAPPER.other);
        }
        break;
      default:
    }
  };

  handleOnThanks = () => {
    this.setState({ stepTwo: false });
    if (this.state.modalContentState === 'other') {
      this.props.revertCancellation();
      this.resetModal();
    } else {
      this.props.cancelSubscription(OPTIONS_MAPPER[this.state.selectedOption]);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.cancelSubscriptionSuccess) {
      this.props.setCancelSubscriptionSuccess(false);
      this.resetModal(true);
    }
    if (nextProps.cancelSubscriptionMessage.text !== '') {
      this.hideMessage(this.props.setCancelSubscriptionMessage);
    }
  }

  hideMessage = (functionParam) => {
    setTimeout(() => {
      functionParam({ type: 'success', text: '' });
    }, 3000);
  };

  resetModal = (redirect = false) => {
    this.setState({
      stepOne: false,
      selectedOption: '',
      modalContentState: 'main',
    });
    this.props.onClose(false, redirect);
  };

  goCancelSubscriptionStep = () => {
    this.setState({ stepOne: false });
  };

  goStepOne = () => {
    this.setState({ stepOne: true, selectedOption: '' });
  };

  selectRadioOption = (value) => {
    this.setState({ selectedOption: value });
  };

  handleOnIconClose = () => {
    if (this.state.modalContentState === 'other') {
      this.resetModal(true);
    } else {
      this.resetModal(false);
    }
  };

  handleCancellationReasonChange = (reason) => {
    this.setState({ cancellationReason: reason });
  };

  render() {
    const disabledButton =
      this.state.selectedOption === '' ||
      this.props.cancelSubscriptionWaiting ||
      (this.state.selectedOption == 'other' &&
        this.state.stepTwo &&
        (this.state.cancellationReason == '' ||
          !noSpacesRegex.test(this.state.cancellationReason)));

    return (
      <Modal
        isOpen={this.props.isOpen}
        className="cancel-popup-content modal-dialog-centered mx-auto"
        modalClassName="calcel-popup"
        toggle={this.props.onClose}
      >
        <div className="cancel-popup-header">
          <div className="title">
            {TITLE_MAPPER[this.state.modalContentState].title}
            <i className="icon-close" onClick={this.handleOnIconClose} />
          </div>
          <div className="description">
            {TITLE_MAPPER[this.state.modalContentState].subtitle}
          </div>
        </div>
        <div className="gradient-divider" />
        {this.state.stepOne && (
          <ModalBody>
            <div className="cancel-popup-item-row border-bottom">
              <i className="material-icons green-check-icon">check_circle</i>
              <div className="item-description">
                Keep access to the private forum community
              </div>
            </div>
            <div className="cancel-popup-item-row">
              <i className="material-icons green-check-icon">check_circle</i>
              <div className="item-description">
                Your subscription will renew automatically in 3 months.
              </div>
            </div>
            <button
              className="btn btn-danger pause-subscription-button btn-block"
              onClick={this.pauseSubscription}
            >
              pause subscription
            </button>
            <div className="cancel-subscription-link">
              <div className="text" onClick={this.goCancelSubscriptionStep}>
                Cancel Subscription
              </div>
            </div>
          </ModalBody>
        )}
        {!this.state.stepOne && this.state.modalContentState === 'main' && (
          <ModalBody>
            <div className="cancel-popup-item-row border-bottom mt-3">
              <div
                className={
                  this.state.selectedOption === 'tech'
                    ? 'radio-selected'
                    : 'radio-empty'
                }
                onClick={() => this.selectRadioOption('tech')}
              />
              <div className="item-description">{OPTIONS_MAPPER.tech}</div>
            </div>
            <div className="cancel-popup-item-row border-bottom">
              <div
                className={
                  this.state.selectedOption === 'content'
                    ? 'radio-selected'
                    : 'radio-empty'
                }
                onClick={() => this.selectRadioOption('content')}
              />
              <div className="item-description">{OPTIONS_MAPPER.content}</div>
            </div>
            <div className="cancel-popup-item-row border-bottom">
              <div
                className={
                  this.state.selectedOption === 'need'
                    ? 'radio-selected'
                    : 'radio-empty'
                }
                onClick={() => this.selectRadioOption('need')}
              />
              <div className="item-description">{OPTIONS_MAPPER.need}</div>
            </div>
            <div className="cancel-popup-item-row">
              <div
                className={
                  this.state.selectedOption === 'other'
                    ? 'radio-selected'
                    : 'radio-empty'
                }
                onClick={() => this.selectRadioOption('other')}
              />
              <div className="item-description">{OPTIONS_MAPPER.other}</div>
            </div>
            <button
              className="btn btn-danger pause-subscription-button btn-block"
              onClick={this.handleOnSubmit}
              disabled={disabledButton}
              style={{ marginBottom: 15 }}
            >
              {this.props.cancelSubscriptionWaiting ? (
                <CircularLoading className="loading-gif-btn" />
              ) : (
                'Submit'
              )}
            </button>
            {this.props.cancelSubscriptionMessage.type === 'error' &&
              this.props.cancelSubscriptionMessage.text !== '' && (
                <div className="message-error">
                  {this.props.cancelSubscriptionMessage.text}
                </div>
              )}
          </ModalBody>
        )}
        {!this.state.stepOne && this.state.modalContentState !== 'main' && (
          <ModalBody>
            <div className="my-4">
              {this.state.modalContentState === 'other' ? (
                <div>
                  <Input
                    id="cancellation-option-other"
                    className="my-profile-input"
                    placeholder="I want to cancel because..."
                    value={this.state.cancellationReason}
                    onChange={(e) =>
                      this.handleCancellationReasonChange(
                        String(e.target.value),
                      )
                    }
                    disabled={false}
                  />
                </div>
              ) : (
                TITLE_MAPPER[this.state.modalContentState].bodyMessage.map(
                  (paragraph, index) =>
                    index === 0 ? (
                      <p key={index}>{paragraph}</p>
                    ) : (
                      <p key={index}>{paragraph}</p>
                    ),
                )
              )}
            </div>

            <button
              className="btn btn-danger pause-subscription-button btn-block"
              onClick={this.handleOnSubmit}
              disabled={disabledButton}
            >
              {this.props.cancelSubscriptionWaiting ? (
                <CircularLoading className="loading-gif-btn" />
              ) : (
                TITLE_MAPPER[this.state.modalContentState].buttonLabel
              )}
            </button>
            {this.props.cancelSubscriptionMessage.type === 'error' &&
              this.props.cancelSubscriptionMessage.text !== '' && (
                <div className="message-error">
                  {this.props.cancelSubscriptionMessage.text}
                </div>
              )}
            <div className="cancel-subscription-link smaller">
              <div
                className="text"
                onClick={() => {
                  if (!this.props.cancelSubscriptionWaiting) {
                    this.handleOnThanks();
                  }
                }}
              >
                {' '}
                {this.state.selectedOption === 'other'
                  ? 'Nevermind, I don’t want to cancel.'
                  : 'No Thanks'}
              </div>
            </div>
          </ModalBody>
        )}
      </Modal>
    );
  }
}

export default CancelPopUp;
